import React from "react";
import PeerLogo from "../../../assets/images/peerislands.svg";
import PeerAILogo from "../../../assets/images/peerai_white.png";
import "../ActionsSideBar/activeSideBar.scss"
import PropTypes from "prop-types";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import {  Link } from "react-router-dom";
import { useState } from "react";
import { FcExpand } from "react-icons/fc";
import { FcCollapse } from "react-icons/fc";

// PropTypes validation
ActionSidebar.propTypes = {
  projects: PropTypes.array,
  activeProject: PropTypes.string.isRequired,
  handleActiveProject: PropTypes.any.isRequired,
  activeProjectFiles: PropTypes.any.isRequired,
  setFile: PropTypes.any.isRequired,
  selectedFile: PropTypes.any.isRequired
};

export default function ActionSidebar({
  projects,
  activeProject,
  handleActiveProject,
  activeProjectFiles,
  setFile,
  selectedFile,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [FilesearchTerm, setFileSearchTerm] = useState(""); 
  const [isCollapsed, setIsCollapsed] = useState(false);
  const handleCheckboxChange=(file)=>{
    if(selectedFile.includes(file)){
      setFile(selectedFile.filter((files) => files !== file));
    }
    else{
      setFile([...selectedFile,file])
    }
  }
  
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter the projects based on the search term
  const filteredProjects = projects.filter((item) =>
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleFileSearch = (e) => {
    setFileSearchTerm(e.target.value);
    console.log(e.target.value);
    
  };

  const filteredFiles = activeProjectFiles.filter((item) =>
    item.toLowerCase().includes(FilesearchTerm.toLowerCase())
  );
  const toggleCollapse = () => {
    console.log(isCollapsed);
    setIsCollapsed((prev) => !prev);
  };
  return (
    <div className="column form-column">
      <div className="icons">
      <Link to="/"><IoArrowBackCircleSharp size={40}/></Link> 
      </div>
      <div className="top">
        <div className="header">
          <div className="logo">
            <img src={PeerLogo} alt="logo" />
            <div className="divider"></div>
            <img src={PeerAILogo} alt="logo" />
          </div>
        
        </div>
        <div className="main">
        <h3 style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        Projects
        <button
          onClick={toggleCollapse}
          style={{
            padding: "5px 10px",
            border: "none",
            // backgroundColor: "#007bff",
            color: "#fff",
            cursor: "pointer",
            borderRadius: "4px",
          }}
        >
          {isCollapsed ? <FcCollapse/>: <FcExpand/>}
        </button>
      </h3>
      {!isCollapsed &&( <ul className="projectMenu">
        <input
        type="text"
        placeholder="Search projects..."
        value={searchTerm}
        onChange={handleSearch}
        className="search-bar"
        style={{
          padding: "8px",
          margin: "10px 0",
          width: "100%",
          border: "1px solid #ccc",
          borderRadius: "4px",
          color:"black"
        }}
      />
          {filteredProjects?.map((item, i) => {
            return (
              <li key={i} className="sessions">
                <p
                  className={item=== activeProject ? "active" : ""}
                  onClick={() => {
                    handleActiveProject(item);
                  }}
                >
                  {item}   
                </p>
              </li>
            );    
          })}
        </ul>
      )
    }
        <hr></hr>
        <h3>Files</h3>
        <ul className="files">
        <input
        type="text"
        placeholder="Search files..."
        value={FilesearchTerm}
        onChange={handleFileSearch}
        className="search-bar"
        style={{
          padding: "8px",
          margin: "10px 0",
          width: "100%",
          border: "1px solid #ccc",
          borderRadius: "4px",
          color:"black"
        }}
      />
          {filteredFiles?.map((item, i) => {
            return (
              <li key={i} className="sessions">
                <input
              type="checkbox"
              checked={selectedFile.includes(item)}
              onChange={() => handleCheckboxChange(item)}
            />
                <p
                  className={item === selectedFile ? "active" : ""}
                  onClick={()=>{
                    setFile([item])
                  }}
                >

                  {item}   
                </p>
              </li>
            );    
          })}
        </ul>
      </div>
      {/* <ActionSearch config={config} setConfig={setConfig} selectedFile={selectedFiles} performAction={performAction} /> */}
    </div>
    </div>
  );
}
